'use client'

import {
  Tooltip as TooltipMain,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
  
interface TooltipProps {
  children: React.ReactNode
  content: any
  // The child is the trigger itself. Needed when the child is, or holds, a button: the default
  // trigger is a button too, and a button cannot sit inside another.
  asChild?: boolean
  [key: string]: any
}

export default function Tooltip({ children, content, asChild = false }: TooltipProps) {
  return (
    <TooltipProvider>
      <TooltipMain>
        <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
        <TooltipContent>
          {content}
        </TooltipContent>
      </TooltipMain>
    </TooltipProvider>
  )
}
